<section>

    @if ((courseType$ | async)?.mode == 'edit') {
    <div class="mb-10">
        <app-course-card
          [data]="courseData$ | async"
          (statusChanged)="onCourseStatusChanged($event)">
        </app-course-card>
    </div>
    }


    <div class="">
        <div role="tablist" class="tabs tabs-bordered px-3 capitalize">
            @for (i of tabs; track $index) {
            <button role="tab" class="tab hover:rounded-t-md capitalize" [disabled]="i.islock" (click)="setTab(i.value)"
                [ngClass]="{'tab-active': currentTab == i.value}">{{i.name}}</button>
            }
        </div>
    </div>

    <div class=" grid grid-cols-2 relative">
        <!-- main forms -->
        <div [ngClass]="{'col-span-1':isTabDevicePreview,'col-span-2':!isTabDevicePreview}">
            <div class="mt-10 max-w-3xl">

                <ng-container [ngSwitch]="currentTab">

                    <app-general-form *ngSwitchCase="'general'"></app-general-form>
                    <!---->
                    <ng-template [ngSwitchCase]="'structure'">

                        @if ((courseType$ | async)?.type === 'video') {
                        <app-video-structure></app-video-structure>
                        }@else if ((courseType$ | async)?.type === 'flashcard') {
                        <app-flashcard-structure></app-flashcard-structure>
                        }

                    </ng-template>
                    <!---->
                    <app-details *ngSwitchCase="  'details'"></app-details>
                    <!---->
                    <app-others *ngSwitchCase="  'other'"></app-others>
                    <!---->
                    <app-review *ngSwitchCase="  'review'"></app-review>
                    <!---->
                    <app-purchases *ngSwitchCase="  'purchases'"></app-purchases>
                    <!---->
                    <app-analytics *ngSwitchCase="  'analytics'"></app-analytics>

                </ng-container>
            </div>
        </div>

        <!-- main forms -->
        <!-- device preview -->
        @if (isTabDevicePreview) {
        <div class="col-span-1">
            <div class="p-5">
                <div class="relative w-full aspect-[768/1024]">
                    <!-- Tablet Frame Image -->
                    <img src="assets/deviceTab.png" class="w-full h-auto relative z-[0] pointer-events-none"
                        alt="Tablet Frame" />

                    <!-- Content Area Inside Mockup -->
                    <div class="absolute top-0 left-0 w-full h-full z-[0] flex justify-center items-center">
                        <div #previewWrapper class="w-[84%] h-[76%] overflow-hidden relative bg-white"
                            style="pointer-events: auto;">
                            <!-- Scaling Container -->
                            <div class="absolute top-0 left-0" [style.transform]="'scale(' + scale + ')'"
                                [style.width.px]="contentWidth" [style.height.px]="contentHeight"
                                [style.transformOrigin]="'top left'">
                                <app-device-preview></app-device-preview>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        <!-- device preview -->

        @if (isTabDevicePreview) {
        <button (click)="isTabDevicePreview = false"
            class="btn bg-white text-black btn-sm absolute z-0 top-5 right-16 flex items-center"><i
                class="ri-close-line"></i><span>Hide Preview</span></button>

        }@else{
        <button (click)="isTabDevicePreview = true"
            class="btn bg-black text-white rounded-full btn-sm absolute z-0 top-5 right-16 flex items-center"><i
                class="ri-smartphone-line font-thin"></i><span>Show Preview</span> </button>
        }

    </div>


</section>